import { render } from "./ReturnScan.vue?vue&type=template&id=3c77bfa4&scoped=true"
import script from "./ReturnScan.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnScan.vue?vue&type=script&setup=true&lang=js"

import "./ReturnScan.vue?vue&type=style&index=0&id=3c77bfa4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c77bfa4"],['__file',"src/pages/components/templates/returnScan/ReturnScan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c77bfa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c77bfa4', __exports__)) {
    console.log('reload')
    api.reload('3c77bfa4', __exports__)
  }
  
  module.hot.accept("./ReturnScan.vue?vue&type=template&id=3c77bfa4&scoped=true", () => {
    console.log('re-render')
    api.rerender('3c77bfa4', render)
  })

}


export default __exports__